var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-breadcrumb",
        [
          _c(
            "w-row",
            { attrs: { grow: "" } },
            [
              _c("w-tabs", {
                attrs: { tabs: _vm.tabs },
                model: {
                  value: _vm.activeTab,
                  callback: function ($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab",
                },
              }),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel mr",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.cancel")) + " ")]
              ),
              _c(
                "w-button",
                {
                  attrs: { icon: "check" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        {
          style: { paddingTop: "0", height: "100%" },
          attrs: { tag: "w-container", grow: "" },
        },
        [
          _vm.state.crm.ID != 0
            ? _c(
                "w-row",
                { style: { height: "100%" } },
                [
                  _c(
                    "w-col",
                    {
                      style: { flexGrow: 1 },
                      attrs: {
                        md: _vm.currentTabKey == "activities" ? 8 : 12,
                        xs: "12",
                      },
                    },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "fast-fade", mode: "out-in" } },
                        [
                          _vm.currentTabKey == "activities"
                            ? _c("app-crm-history", {
                                attrs: {
                                  crm: _vm.state.crm,
                                  action: _vm.action,
                                  contact: _vm.state.crm.Contact,
                                  history: _vm.sortedHistory,
                                  state: _vm.state,
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.triggerAction($event)
                                  },
                                  save: function ($event) {
                                    return _vm.saveHistory($event)
                                  },
                                  update: function ($event) {
                                    return _vm.updateHistory($event)
                                  },
                                },
                              })
                            : _vm.currentTabKey == "documents"
                            ? _c("app-sale-search-browse", {
                                attrs: {
                                  "contact-id": _vm.state.crm.ContactID,
                                  "crm-id": _vm.state.crm.ID,
                                  "allow-view-button": true,
                                  "book-year-select": true,
                                  "clear-view-settings-filters": true,
                                },
                                on: {
                                  "close-update": function ($event) {
                                    return _vm.closeSaleBrowse()
                                  },
                                },
                              })
                            : _vm.currentTabKey == "extra-fields"
                            ? _c("app-crm-edit-extra-fields", {
                                attrs: {
                                  xs: "12",
                                  value: _vm.state.crm.ExtraFields,
                                  lg: _vm.otherTabColWidth,
                                  md: _vm.otherTabColWidth,
                                },
                              })
                            : _vm.currentTabKey == "files"
                            ? _c("app-crm-documents-tab", {
                                attrs: { crm: _vm.state.crm },
                              })
                            : _c("app-extra-field-tab", {
                                key: "extra-field-" + _vm.activeTab,
                                attrs: {
                                  value: _vm.state.crm.ExtraFields,
                                  tab: _vm.extraFieldTabs[
                                    _vm.activeTab - _vm.extraFieldTabStart
                                  ],
                                  "name-settings": _vm.extraFieldNamesConfig,
                                },
                              }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.currentTabKey == "activities"
                    ? _c("app-crm-edit-general", {
                        attrs: {
                          crm: _vm.state.crm,
                          lg: _vm.colWidth,
                          md: _vm.colWidth,
                          xs: "12",
                        },
                        on: {
                          save: function ($event) {
                            return _vm.save($event)
                          },
                          "trigger-phone": function ($event) {
                            return _vm.triggerPhone($event)
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "w-row",
                [
                  _c(
                    "transition",
                    { attrs: { name: "fast-fade", mode: "out-in" } },
                    [
                      _vm.activeTab == 2
                        ? _c(
                            "w-col",
                            {
                              attrs: {
                                xs: "12",
                                lg: _vm.otherTabColWidth,
                                md: _vm.otherTabColWidth,
                              },
                            },
                            [
                              _c("app-crm-edit-extra-fields", {
                                attrs: { value: _vm.state.crm.ExtraFields },
                              }),
                            ],
                            1
                          )
                        : _vm.activeTab < 2
                        ? _c("app-crm-edit-general", {
                            attrs: {
                              crm: _vm.state.crm,
                              lg: _vm.colWidth,
                              md: _vm.colWidth,
                              xs: "12",
                            },
                            on: {
                              save: function ($event) {
                                return _vm.save($event)
                              },
                              "trigger-phone": function ($event) {
                                return _vm.triggerPhone($event)
                              },
                            },
                          })
                        : _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-extra-field-tab", {
                                key: "extra-field-" + _vm.activeTab,
                                attrs: {
                                  value: _vm.state.crm.ExtraFields,
                                  tab: _vm.extraFieldTabs[
                                    _vm.activeTab - _vm.extraFieldTabStart
                                  ],
                                  "name-settings": _vm.extraFieldNamesConfig,
                                },
                              }),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }